import React, { Fragment } from 'react'

const Transparentspinner = () => {
    return (
        <Fragment>
            <div className='loader-transparent' style={{ display: 'flex' }}>
                <div className="loader"></div>
            </div>
        </Fragment>
    )
}

export default Transparentspinner